import { Pipe, PipeTransform } from '@angular/core';
import { TIC_SPECIALTY_CATEGORY } from '@app/config/tic-name.enum';

@Pipe({
  name: 'ticSpecialtyIndex'
})
export class TicSpecialtyIndexPipe implements PipeTransform {

  public dataSelectTic = TIC_SPECIALTY_CATEGORY.map(b => { return b });

  transform(value: any): number {

    return this.dataSelectTic.findIndex(x => x.id === value);
  }
}